<template>
  <sdx-header
      id="header"
      v-if="loggedIn"
      :navigation="loggedInComputed.navigation"
      :slots="loggedInComputed.slots"
      :index="headerIndex"
      @sdxnavigate="(event) => navigate(event.detail.item.href, event)"
  >
    <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
    <div slot="logout" class="padding-2">
      <hr class="margin-top-0"/>
      <ul class="margin-top-0">
        <li v-if="envService.featureToggleBillingProfile4User()">
          <a href="/billing/profiles" class="link" @click="(event) => navigate('/billing/profiles/view/user', event)">
            <sdx-icon icon-name="icon-coins"/>
            Billing Profiles
          </a>
        </li>
        <li>
          <a href="/subscription/details" class="link" @click="(event) => navigate('/subscription/details', event)">
            <sdx-icon icon-name="icon-api"/>
            Subscription Details
          </a>
        </li>
        <li>
          <a href="/user" class="link" @click="(event) => navigate('/user', event)">
            <sdx-icon icon-name="icon-account"/>
            User Information
          </a>
        </li>
        <li class="margin-top-2">
          <a href="/logout" class="link" @click="(event) => navigate('/logout', event)">
            <sdx-icon icon-name="icon-gateway"/>
            Logout
          </a>
        </li>
      </ul>
    </div>
  </sdx-header>

  <sdx-header
      id="header"
      v-if="!loggedIn"
      :navigation="loggedOutComputed.navigation"
      :slots="loggedOutComputed.slots"
      :index="headerIndex"
  >

  </sdx-header>

</template>

<script>
import userService from '@/services/user.service';
import {getCurrentLanguage} from "@/i18n/i18n";
import envService from "@/services/env.service";
export default {
  data() {
    return {
      loggedIn: false,
      headerIndex: {
        label: 'Home',
        href: '/home'
      },
    };
  },
  created() {
  },
  mounted() {
    this.loggedIn = this.isLoggedIn();
    window.vueWrapper = this;
  },
  methods: {
    isLoggedIn() {
      return userService.isLoggedIn();
    },
    getUserName() {
      let user = userService.getLoggedInUser();
      return (user && user.name) || '';
    },
    navigate(path, event) {
      event.preventDefault();
      let sdxHeaders = document.getElementsByTagName('sdx-header');
      if (sdxHeaders && sdxHeaders.length > 0) {
        sdxHeaders[0].closeSlot('logout');
      }
      this.$router.push(path);
    }
  },
  computed: {
    envService() {
      return envService
    },
    userService() {
      return userService
    },
    currentLanguage() {
      return getCurrentLanguage().toUpperCase()
    },
    loggedInComputed() {
      return {
        slots: [
          {
            label: this.getUserName(),
            showLabelOnDesktop: true,
            iconName: 'icon-account',
            slot: "logout",
          },
        ],
        navigation: {
          main: {
            children: [
              {
                label: 'Statistics',
                href: '/statistics',
                hidden: !envService.featureToggleStats() || !userService.hasRightSms(),
              },
              {
                label: 'Outbox',
                href: '/outbox',
                hidden: !envService.featureToggleSmsOutbox() || !userService.hasRightSms(),
              },
              {
                label: 'Inbox',
                href: '/inbox',
                hidden: !envService.featureToggleSmsInbox() || !userService.hasRightReceiveSms(),
              },
              {
                label: 'Campaigns',
                hidden: !(envService.featureToggleCampaign() || envService.featureToggleQuickGuide()) || !userService.hasRightCampaignManager(),
                children: [
                  {
                    label: 'Create',
                    href: '/campaigns/create',
                    hidden: !userService.hasRightCampaignManager(),
                  },
                  {
                    label: 'Overview',
                    href: '/campaigns',
                    hidden: !userService.hasRightCampaignManager(),
                  },
                  {
                    label: 'QuickGuide',
                    href: '/campaigns/quickguide',
                    hidden: !envService.featureToggleQuickGuide(),
                  }
                ]

              },
              {
                label: 'Tools',
                children: [
                  {
                    label: 'Unicode Detector',
                    href: '/unicode-detector',
                    hidden: !envService.featureToggleUnicodeDetector(),
                  },
                  {
                    label: 'Send SMS',
                    href: '/sendsms',
                    hidden: !envService.featureToggleSendSms() || !userService.hasRightSendSms(),
                  }
                ]
              },
              {
                label: 'API Products',
                href: '/api-products',
              },
              {
                label: 'Configuration',
                children: [
                  {
                    label: 'Allow List',
                    href: '/prefix/allowlist',
                  },
                ]
              },
            ],
          },
          secondary: {
            label: 'Contact & Language',
            children: [
              {
                label: 'Admin',
                hidden: !userService.isAdmin() && !userService.hasRightBilling(),
                children: [
                  {
                    label: 'Activate Browser Debug Logging',
                    href: '/home?logging=debug',
                    hidden: !userService.isAdmin(),
                  },
                  {
                    label: 'Activate Feature ...',
                    href: '/home?feature=',
                    hidden: !userService.isAdmin(),
                  },
                  {
                    label: 'Billing Profiles',
                    href: '/billing/profiles',
                    hidden: !envService.featureToggleBillingProfile() || !userService.hasRightBilling(),
                  },
                  {
                    label: 'Billing Status',
                    href: '/billing/status',
                    hidden: !userService.isAdmin(),
                  },
                  {
                    label: 'Rules',
                    href: '/rules',
                    hidden: !userService.isAdmin(),
                  },
                  {
                    label: 'Block List',
                    href: '/prefix/blocked',
                    hidden: !userService.isAdmin() || !envService.featureToggleDenyList(),
                  }
                ]
              }
            ]
          },
          tertiary: {
            label: 'Contact & Language',
            children: [
              {
                label: 'Contact',
                href: '/contact',
              },
              {
                label: this.currentLanguage,
                hidden: true,
                children: [
                  {
                    label: 'EN',
                    href: 'javascript:this.vueWrapper.setLanguage(\'en\');document.getElementById(\'app\').click();location.reload();',
                  },
                  {
                    label: 'DE',
                    href: 'javascript:this.vueWrapper.setLanguage(\'de\');document.getElementById(\'app\').click();location.reload();',
                  },
                ],
              },
            ],
          },
        },
      };
    },
    loggedOutComputed() {
      return {
        slots: [
          {
            label: 'Login',
            href: '/login',
            iconName: 'icon-account',
            hidden: !envService.featureToggleLogin()
          }
        ],
        navigation: {
          main: {
            label: 'Navigation',
            children: [
              {
                label: 'API Products',
                href: '/',
              },
              {
                label: 'Campaigns',
                hidden: !envService.featureToggleCampaign() || !envService.featureToggleQuickGuide(),
                children: [
                  {
                    label: 'QuickGuide',
                    href: '/campaigns/quickguide',
                  }
                ]

              },
              {
                label: 'Tools',
                children: [
                  {
                    label: 'Unicode Detector',
                    href: '/unicode-detector',
                    hidden: !envService.featureToggleUnicodeDetector(),
                  },
                ]

              },
            ],
          },
          tertiary: {
            label: 'Language',
            children: [
              {
                label: this.currentLanguage,
                hidden: true,
                children: [
                  {
                    label: 'EN',
                    href: 'javascript:this.vueWrapper.setLanguage(\'en\');document.getElementById(\'app\').click();location.reload();',
                  },
                  {
                    label: 'DE',
                    href: 'javascript:this.vueWrapper.setLanguage(\'de\');document.getElementById(\'app\').click();location.reload();',
                  },
                ],
              }
            ],
          },
        },
      };
    },
  },
};
</script>

<style scoped>

</style>
